import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface Props {
  /** Page key theo nav.ts / ROLE_PAGES. */
  page: string;
  children: ReactNode;
}

/**
 * Route guard theo trang: user phải có `page` trong `user.pages` (server return).
 * - Chưa login → /login
 * - Login rồi nhưng không có quyền xem trang → /dashboard (hoặc /mypayslips nếu là NV)
 */
export function RequirePage({ page, children }: Props) {
  const { user, loading, logout } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;

  const pages = user.pages ?? [];
  if (pages.includes(page)) return <>{children}</>;

  // NV không có dashboard — bay về mypayslips
  const fallbackKey = user.role === 'NV' ? 'mypayslips' : 'dashboard';

  // Không có cả trang fallback (role lạ từ Base như admin/staff, hoặc chưa được gán
  // vai trò kế toán) thì PHẢI dừng ở đây với thông báo. Navigate về /dashboard trong
  // khi chính /dashboard đang bị chặn là redirect lặp vô hạn — màn trắng, dính thật 11/08.
  if (!pages.includes(fallbackKey)) {
    return (
      <div style={{ display: 'flex', height: '100vh', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, color: '#334155', fontFamily: 'Inter, sans-serif', textAlign: 'center', padding: 24 }}>
        <h2 style={{ margin: 0 }}>Tài khoản chưa được cấp vai trò trong Kế toán</h2>
        <p style={{ margin: 0, color: '#64748b' }}>
          Đăng nhập SSO thành công ({user.email}), nhưng vai trò hiện tại chưa được gán quyền xem trang nào.
          Liên hệ Kế toán trưởng để được cấp vai trò.
        </p>
        <button onClick={() => void logout()} style={{ marginTop: 8, padding: '8px 20px', cursor: 'pointer' }}>Đăng xuất</button>
      </div>
    );
  }

  return <Navigate to={fallbackKey === 'mypayslips' ? '/mypayslips' : '/dashboard'} replace />;
}
